import React, { Component } from 'react'
import { FormattedMessage, FormattedNumber } from 'react-intl'
import QuoteItemPrice from "../../../../common/quote/itemprice.component.jsx";
import LabelUnitOfMeasure from '../../../../common/unit-of-measure/label.component.jsx'
import CommitmentDurationLabel from "../../../../common/pricing/commitmentdurationlabel.component.jsx"
import QuoteGroupName from "../../../../common/quote/groupname.component.jsx"
import BillingMethodLabel from "../../../../product/billing-method/label.component.jsx"
import DocumentPricingTableTotalWord from "./wordtotal.component.jsx"

class PricingTableContentSection extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            section: this.props.section || null,
            variables: this.props.variables || null,
            editable: this.props.editable || false,
            isPdf: this.props.isPdf || false,
            isDummy: this.props.isDummy || false,
            edition: this.props.edition || false,
            onEdit: this.props.onEdit || function () {
            },
            itemOptions: [],
            taxCalculations: [],
            totals: [],
            optionsSelected: {},
            subtotalAmount: '0',
            discountAmount: '0',
            taxAmount: '0',
            totalAmount: '0',
        }
        if (this.state.variables) {
            this.state.optionsSelected = this.formatOptions(this.state.variables)
            this.state.totals = this.state.variables.quote.totals
            this.state.subtotalAmount = this.state.variables.quote.subtotalAmount
            this.state.discountAmount = this.state.variables.quote.discount.amount
            this.state.taxCalculations = this.state.variables.quote.taxCalculations
            this.state.taxAmount = this.state.variables.quote.taxAmount
            this.state.totalAmountWithoutTax = this.state.variables.quote.totalAmountWithoutTax
            this.state.totalAmount = this.state.variables.quote.totalAmount
            this.state.itemOptions = this.formatItemOptions(this.state.variables)
        }
    }


    getItemOption(itemId) {
        const option = this.state.itemOptions.filter(i => i.itemId === itemId)
        return option.length > 0 ? option[0] : {}
    }


    formatOptions(proposal) {
        const options = {}
        for (let index in proposal.quote.items) {
            const item = proposal.quote.items[index]
            options[item.id] = item.isOptionChecked
        }
        return options
    }

    formatItemOptions(proposal) {
        return proposal.quote.items.map(i => {
            return {
                editMode: false,
                titleOverride: i.option.titleOverride,
                shortDescriptionOverride: i.option.shortDescriptionOverride,
                hideAssemblyDetails: i.option.hideAssemblyDetails,
                itemId: i.id,
                title: i.option.title,
                shortDescription: i.option.shortDescription,
                longDescription: i.option.longDescription,
                longDescriptionOverride: i.option.longDescriptionOverride || false,
            }
        })
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.variables !== this.state.variables) {
            this.setState({
                variables: nextProps.variables || null,
                section: nextProps.section || null,
                optionsSelected: this.formatOptions(nextProps.variables),
                subtotalAmount: nextProps.variables.quote.subtotalAmount,
                totalAmountWithoutTax: nextProps.variables.quote.totalAmountWithoutTax,
                discountAmount: nextProps.variables.quote.discount.amount,
                taxAmount: nextProps.variables.quote.taxAmount,
                totalAmount: nextProps.variables.quote.totalAmount,
                totals: nextProps.variables.quote.totals,
                isPdf: nextProps.isPdf || false,
                isDummy: nextProps.isDummy || false,
            })
        }
    }

    renderItems(billingMethod, types, separator, groupId) {
        const allowedItems = this.state.variables.quote.items.filter(i => i.billingMethod === billingMethod && groupId === i.groupId && types.includes(i.type) && !i.isOption)
        let items = allowedItems.map((item, index) => {
            let label = ''
            if (item.isProvidedByCustomer) {
                label = <small><span className="badge badge-info">
                    <FormattedMessage
                        id="proposal.items.provided_by_customer"
                        defaultMessage="Provided by customer"
                    />
                </span>
                    &nbsp;
                    &nbsp;
                </small>
            }
            if (item.isExtraFee) {
                let quoteItemPrice = <QuoteItemPrice value={item.itemObject} />
                if (parseFloat(item.measure) > 0) {
                    quoteItemPrice = <FormattedNumber
                        style="currency"
                        currency={this.state.variables.quote.currency}
                        value={item.subtotalAmount}
                        key={"subtotal-" + item.id}
                    />
                }

                label = <small>
                    <span className="badge badge-secondary">
                        <FormattedMessage
                            id="proposal.items.extra_fee"
                            defaultMessage="Extra fee"
                        />
                    </span>
                    &nbsp;
                    &nbsp;
                    <small>{quoteItemPrice}</small>

                </small>
            }

            if (item.isIncluded) {
                label = <small>
                    <span className="badge badge-primary">
                        <FormattedMessage
                            id="proposal.items.included"
                            defaultMessage="Included"
                        />
                    </span>
                </small>
            }
            let pricing = []
            let price = ''
            if (this.state.section.attributes.content.showLineSubTotal && !item.isProvidedByCustomer && !item.isExtraFee && !item.isIncluded) {
                price = <FormattedNumber
                    style="currency"
                    currency={this.state.variables.quote.currency}
                    value={item.subtotalAmount}
                    key={"subtotalAmount-" + item.id}
                />
                if (item.discountValue != 0) {
                    let discountValue = ''
                    if (item.discountType === 'currency-value') {
                        discountValue = <FormattedNumber
                            style="currency"
                            currency={this.state.variables.quote.currency}
                            value={-item.discountValue}
                            key={"discountValue-" + item.id}
                        />
                    } else {
                        discountValue = <FormattedNumber
                            style="percent"
                            value={-(parseFloat(item.discountValue) / 100)}
                            key={"discountValue-" + item.id}
                        />
                    }
                    price = <div>
                        <FormattedNumber
                            style="currency"
                            currency={this.state.variables.quote.currency}
                            value={item.subtotalAmountWithoutDiscount}
                        />
                        <br />
                        ({discountValue})
                        &nbsp;
                        <FormattedNumber
                            style="currency"
                            currency={this.state.variables.quote.currency}
                            value={item.subtotalAmount}
                        />
                    </div>
                }
                if (price !== '') {
                    pricing.push(price)
                }
                if (item.billingMethod !== 'one-time') {
                    let label = <FormattedMessage
                        id="proposal.total.per_month_label"
                        defaultMessage="per month"
                    />
                    if (item.billingMethod === "yearly") {
                        label = <FormattedMessage
                            id="proposal.total.per_year_label"
                            defaultMessage="per year"
                        />
                    }
                    pricing.push(<p style={{ margin: '0' }}>{label}</p>)
                }
            }

            if (item.billingMethod !== 'one-time') {
                if (item.commitmentDuration > 0) {
                    pricing.push(<p style={{ margin: '0' }}>
                        <CommitmentDurationLabel value={item.commitmentDuration} billingMethod={item.billingMethod} />
                    </p>)
                }
            }


            let title = ''
            let shortDescription = ''
            let longDescription = ''
            let assemblyInfo = ''
            let measure = ''

            const itemOption = this.getItemOption(item.id)

            if (!item.isExtraFee) {
                const times = item.unitOfMeasure !== "travel" ? <strong>×</strong> : ''
                measure = <span className="mr-1">
                    <small>
                        <LabelUnitOfMeasure
                            unit={item.unitOfMeasure}
                            value={item.measure}
                            format='short'
                        />
                        &nbsp;
                        {times}
                    </small>
                </span>
            }
            let titleText = item.product.title
            if (itemOption.titleOverride) {
                titleText = itemOption.title
            }
            title = <p style={{
                border: 'none',
                fontWeight: '600',
                fontSize: '12px',
                color: this.state.variables.global.primaryColor,
                margin: '0'
            }}>
                {titleText}&nbsp;&nbsp;{label}
            </p>

            let shortDescriptionText = item.product.shortDescription
            if (itemOption.shortDescriptionOverride) {
                shortDescriptionText = itemOption.shortDescription
            }
            shortDescription = <div>
                {shortDescriptionText.split('\n').map((item, key) => {
                    return <p style={{ margin: '0' }} key={key}>{item}</p>
                })}
            </div>

            let longDescriptionText = item.product.longDescription
            if (itemOption.longDescriptionOverride) {
                longDescriptionText = itemOption.longDescription
            }
            longDescription = <div className="rich-text">
                <div dangerouslySetInnerHTML={{ __html: longDescriptionText }} />
            </div>

            if (!this.state.section.attributes.content.showShortDescription) {
                shortDescription = ''
            }
            if (!this.state.section.attributes.content.showLongDescription) {
                longDescription = ''
            }

            return <tr key={item.id}>
                <td style={{ verticalAlign: 'top', width: '10%' }}>
                    <h5 className="mt-0 mb-0 pb-0" style={{ border: 'none' }}>
                        {measure}
                    </h5>
                </td>
                <td style={{ verticalAlign: 'middle', width: '70%' }}>
                    {title}
                    {shortDescription}
                    {longDescription}
                </td>
                <td style={{ verticalAlign: 'top', textAlign: 'right', width: '20%' }}>
                    {pricing}
                </td>
            </tr>
        })

        return items
    }

    getBillingMethodOrder() {
        const defaultOrder = ['one-time', 'monthly', 'yearly']
        const hasRankSet = this.state.variables.quote.items.filter(i => i.itemObject.attributes.rank !== 0).length > 0
        if (!hasRankSet) {
            return defaultOrder
        }
        const list = this.state.variables.quote.groups.length > 0 ? this.state.variables.quote.groups : this.state.variables.quote.items
        const methods = list.map(g => {
            return g.attributes ? g.attributes.billingMethod : g.billingMethod
        }).filter((value, index, self) => {
            return self.indexOf(value) === index;
        })

        for (let index in defaultOrder) {
            const method = defaultOrder[index]
            if (!methods.includes(method)) {
                methods.push(method)
            }
        }
        return methods
    }

    render() {
        if (!this.state.variables) {
            return <div />
        }

        const billingMethods = this.state.variables.quote.items.map(r => r.billingMethod).filter((value, index, self) => {
            return self.indexOf(value) === index
        })

        const orders = this.getBillingMethodOrder()
        const totals = this.state.totals.sort((a, b) => {
            return orders.indexOf(a.attributes.billingMethod) - orders.indexOf(b.attributes.billingMethod)
        }).filter(t => billingMethods.includes(t.attributes.billingMethod))
        return <div>
            <br />
            <br />
            {totals.map((t, i) => {
                const rows = this.state.variables.quote.groups.filter(g => g.attributes.billingMethod === t.attributes.billingMethod).map(g => {
                    let pricing = []
                    let label = ''
                    if (g.attributes.billingMethod !== 'one-time') {
                        label = <span className={'mr-2'}>
                            <small>
                                <em>
                                    <BillingMethodLabel value={g.attributes.billingMethod} masculine={true} />
                                </em>
                                &nbsp;&nbsp;
                            </small>
                        </span>
                    }
                    pricing.push(<p className="m-0" key={pricing.length}>
                        {label}
                        <FormattedNumber
                            style="currency"
                            currency={g.attributes.currency}
                            value={g.attributes.subtotalAmount}
                        />
                    </p>)

                    return <div className={'row'} key={'group-' + g.id}>
                        <table style={{
                            width: '100%',
                            fontFamily: this.state.variables.global.font + ', sans-serif',
                            fontSize: '12px',
                            backgroundColor: this.state.variables.global.groupTitleBackgroundColor || '#6c757d',
                            color: '#ffffff',
                            padding: '5px',
                        }}>
                            <tbody>
                                <tr>
                                    <td style={{ width: '80%' }}>
                                        <span>
                                            <QuoteGroupName
                                                showDescription={true}
                                                value={g}
                                                quoteId={this.state.variables.quote.id}
                                                invoiceId={this.state.variables.quote.id}
                                                documentId={this.state.variables.quote.id}
                                                editable={this.state.editable}
                                                withEditIcon={true}
                                                type={this.state.variables.document.id}
                                            />
                                        </span>
                                    </td>
                                    <td style={{ width: '20%', textAlign: 'right' }}>
                                        <strong>{pricing}</strong>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <table style={{
                            width: '100%',
                            fontFamily: this.state.variables.global.font + ', sans-serif',
                            fontSize: '12px',
                            padding: '5px',
                        }}>
                            <tbody>
                                {this.renderItems(
                                    t.attributes.billingMethod,
                                    ['active', 'option-for-customer', 'chosen-by-customer', 'included', 'multiple-choice', 'choice-selected'],
                                    false,
                                    g.id,
                                )}
                            </tbody>
                        </table>
                    </div>
                })
                let title = ''
                let items = ''
                const itemsLength = this.state.variables.quote.items.filter(i => i.billingMethod === t.attributes.billingMethod && "" === i.groupId).length
                if (itemsLength > 0) {
                    title = <table style={{
                        width: '100%',
                        fontFamily: this.state.variables.global.font + ', sans-serif',
                        fontSize: '12px',
                        backgroundColor: this.state.variables.global.groupTitleBackgroundColor || '#6c757d',
                        color: '#ffffff',
                        padding: '5px',
                    }}>
                        <tbody>
                            <tr>
                                <td style={{ width: '100%' }}>
                                    <strong>
                                        <BillingMethodLabel value={t.attributes.billingMethod} masculine={true} />
                                    </strong>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    items = <div className="col-12">
                        <table style={{
                            width: '100%',
                            fontFamily: this.state.variables.global.font + ', sans-serif',
                            fontSize: '12px',
                            padding: '5px',
                        }}>
                            <tbody>
                                {this.renderItems(
                                    t.attributes.billingMethod,
                                    ['active', 'option-for-customer', 'chosen-by-customer', 'included', 'multiple-choice', 'choice-selected'],
                                    false,
                                    ""
                                )}
                            </tbody>
                        </table>
                    </div>
                }

                rows.push(
                    <div className={'row'} key={"no-group-" + rows.length}>
                        {title}
                        {items}
                        <div className={"col-12 " + ((totals.length - 1) !== i ? "mb-5" : "")}>
                            <hr className={"border-color-light-gray"} />
                            <DocumentPricingTableTotalWord
                                total={t}
                                showTaxes={this.state.section.attributes.content.showTaxes}
                                variables={this.state.variables}
                            />
                        </div>
                    </div>
                )
                return rows
            })}
        </div>
    }

}

export default PricingTableContentSection



// WEBPACK FOOTER //
// ./src/template/sections/content/pricing-table/word.component.jsx